import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  const [openIds, setOpenIds] = useState<number[]>([1]);

  const toggleFaq = (id: number) => {
    setOpenIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[800px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            关于蚂蚁影视的常见疑问，这里可能有你想要的答案
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => {
            const isOpen = openIds.includes(item.id);
            return (
              <div
                key={item.id}
                className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(item.id)}
                  className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left hover:bg-background-100/70 transition-colors cursor-pointer"
                >
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-2">
                    {item.question}
                  </h3>
                  <div
                    className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-all ${
                      isOpen
                        ? 'bg-primary-100 text-primary-600 rotate-45'
                        : 'bg-background-100 text-foreground-400'
                    }`}
                  >
                    <i className="ri-add-line text-sm"></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-500 leading-relaxed pl-0 md:pl-0">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}